<template>
  <div class="page-shell">
    <div class="ambient ambient-left"></div>
    <div class="ambient ambient-right"></div>

    <main class="login-layout">
      <section class="brand-panel"></section>

      <section class="card-panel">
        <div class="logo-wrap">
          <img
            class="logo"
            src="/image/logo.png"
            alt="兔灵智绘"
          >
        </div>

        <div class="login-card">
          <div class="card-header">
            <p class="eyebrow">欢迎加入</p>
            <h2>手机号注册</h2>
            <p class="card-copy">请输入真实手机号并完成短信验证码校验。</p>
          </div>

          <form class="login-form" @submit.prevent="submitForm">
            <label class="field">
              <span>姓名</span>
              <input
                v-model.trim="form.name"
                type="text"
                autocomplete="name"
                placeholder="请输入姓名"
              >
            </label>

            <label class="field">
              <span>手机号</span>
              <input
                v-model.trim="form.phone"
                type="tel"
                autocomplete="tel"
                placeholder="请输入 11 位手机号"
              >
            </label>

            <label class="field">
              <span>密码</span>
              <input
                v-model.trim="form.password"
                type="password"
                autocomplete="new-password"
                placeholder="请输入至少 6 位密码"
              >
            </label>

            <label class="field">
              <span>确认密码</span>
              <input
                v-model.trim="form.password_confirmation"
                type="password"
                autocomplete="new-password"
                placeholder="请再次输入密码"
              >
            </label>

            <label class="field">
              <span>短信验证码</span>
              <div class="inline-field">
                <input
                  v-model.trim="form.sms_code"
                  type="text"
                  inputmode="numeric"
                  maxlength="6"
                  placeholder="请输入 6 位验证码"
                >
                <button
                  type="button"
                  class="ghost-button"
                  :disabled="sendingSms || countdown > 0 || !canSendSms"
                  @click="sendSmsCode"
                >
                  {{ smsButtonText }}
                </button>
              </div>
            </label>

            <button class="submit-button" type="submit" :disabled="submitting">
              {{ submitting ? '注册中...' : '注册并进入首页' }}
            </button>
          </form>

          <div class="switch-auth">
            <span>已有账号？</span>
            <router-link :to="{ name: 'login' }">去登录</router-link>
          </div>

          <p v-if="message.text" class="status-text" :class="message.type">
            {{ message.text }}
          </p>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import { register, sendRegisterSmsCode } from "../api/auth";
import { saveAuthState } from "../utils/auth";

var MAINLAND_PHONE_PATTERN = /^1\d{10}$/;
var SMS_CODE_PATTERN = /^\d{6}$/;

export default {
  name: "RegisterView",
  data: function data() {
    return {
      submitting: false,
      sendingSms: false,
      countdown: 0,
      countdownTimer: null,
      form: {
        name: "",
        phone: "",
        password: "",
        password_confirmation: "",
        sms_code: ""
      },
      message: {
        type: "",
        text: ""
      }
    };
  },
  computed: {
    canSendSms: function canSendSms() {
      return MAINLAND_PHONE_PATTERN.test(this.form.phone || "");
    },
    smsButtonText: function smsButtonText() {
      if (this.sendingSms) {
        return "发送中...";
      }

      if (this.countdown > 0) {
        return this.countdown + "s 后重试";
      }

      return "发送验证码";
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.clearCountdown();
  },
  methods: {
    async sendSmsCode() {
      if (!this.canSendSms) {
        this.setMessage("error", "请输入正确的 11 位手机号。");
        return;
      }

      this.sendingSms = true;
      this.setMessage("", "");

      try {
        await sendRegisterSmsCode({
          phone: this.form.phone
        });
        this.setMessage("success", "验证码发送成功。");
        this.startCountdown();
      } catch (error) {
        this.setMessage("error", this.resolveErrorMessage(error));
      } finally {
        this.sendingSms = false;
      }
    },
    async submitForm() {
      var validationMessage = this.validateForm();

      if (validationMessage) {
        this.setMessage("error", validationMessage);
        return;
      }

      this.submitting = true;
      this.setMessage("", "");

      try {
        var payload = await register({
          name: this.form.name,
          phone: this.form.phone,
          password: this.form.password,
          password_confirmation: this.form.password_confirmation,
          sms_code: this.form.sms_code
        });

        saveAuthState({
          accessToken: payload.access_token,
          tokenType: payload.token_type,
          expiresIn: payload.expires_in,
          user: payload.user
        });

        this.$router.push({ name: "home" });
      } catch (error) {
        this.setMessage("error", this.resolveErrorMessage(error));
      } finally {
        this.submitting = false;
      }
    },
    validateForm: function validateForm() {
      if (!this.form.name) {
        return "请输入姓名。";
      }

      if (!MAINLAND_PHONE_PATTERN.test(this.form.phone || "")) {
        return "请输入正确的 11 位手机号。";
      }

      if (!this.form.password || this.form.password.length < 6) {
        return "密码至少需要 6 位。";
      }

      if (this.form.password_confirmation !== this.form.password) {
        return "两次输入的密码不一致。";
      }

      if (!SMS_CODE_PATTERN.test(this.form.sms_code || "")) {
        return "请输入 6 位短信验证码。";
      }

      return "";
    },
    startCountdown: function startCountdown() {
      var self = this;
      this.clearCountdown();
      this.countdown = 60;
      this.countdownTimer = setInterval(function() {
        if (self.countdown <= 1) {
          self.clearCountdown();
          self.countdown = 0;
          return;
        }

        self.countdown -= 1;
      }, 1000);
    },
    clearCountdown: function clearCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
    },
    resolveErrorMessage: function resolveErrorMessage(error) {
      if (error && error.validationErrors) {
        var firstKey = Object.keys(error.validationErrors)[0];
        if (firstKey) {
          return error.validationErrors[firstKey][0];
        }
      }

      return (error && error.message) || "请求失败，请稍后重试。";
    },
    setMessage: function setMessage(type, text) {
      this.message = {
        type: type,
        text: text
      };
    }
  }
};
</script>
